(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/assets/javascripts/betslip-header.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/assets/javascripts/betslip-header.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.betslipv2.Betslip.BetslipHeader = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.app.betslipv2.templates.betslip_header(data);
    },

    model: new Backbone.Model(),

    modelEvents: {
      change: 'render'
    },

    setHeaderText: function(text) {
      this.model.set('headerText', text);
      this.render();
    }
  });
})(Backbone, _, svs);

 })(window);